<template>
    <app-page-options-list :options="options" />
</template>
<script>
    import PageOptionsList from '../../../UI/Controls/PageOptions/PageOptionsList.vue';
    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
        data(){
            return {
                options: [
                    { to: 'clientEntryTimes', label: 'Tiempos de ingreso' }
                ]
            }
        }
    }
</script>